import React from 'react'
import '../Contact/Contact.css'
import {MdOutlineMail} from 'react-icons/md'
import {RiMessengerLine} from 'react-icons/ri'
import {BsWhatsapp} from 'react-icons/bs'
import { useRef } from "react";
import emailjs from '@emailjs/browser';

const Contact = () => {

  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs.sendForm('service_tzxmedj', 'template_buo977w', form.current, '8TceYPP9qWxOuGMYg')
      e.target.reset()
  };

  return (
    <section id='contact'>
      <h5>Get in Touch</h5>
      <h2>Contact Me</h2>

      <div className="container contact__container">
        <div className="contact__options">
          <article className="contact__option">
            <MdOutlineMail className='contact__option-icon'/>
            <h4>Email</h4>
            <h5>chinedunzeteh@gmail.com</h5>
            <a href="mailto:chinedunzeteh@gmail.com" target='_blank'>Send a Message</a>
          </article>
          <article className="contact__option">
            <BsWhatsapp className='contact__option-icon'/>
            <h4>Whatsapp</h4>
            <h5>+234********</h5>
            <a href="https://api.whatsapp.com/send?phone=+2348035527457" target='_blank'>Chat Me Up</a>
          </article>
          <article className="contact__option">
            <RiMessengerLine className='contact__option-icon'/>
            <h4>Messenger</h4>
            <h5>Chinedu Chinzeh Nzeteh</h5>
            <a href="http://m.me/chinzeh" target='_blank'>Message Me</a>
          </article>
        </div>

        <form ref={form} onSubmit={sendEmail}>
          <input type="text" name="name" placeholder='Your Full Name' id="" required/>
          <input type="email" name="email" placeholder='Your Email' id="" required/>
          <textarea name="message" id="" cols="" rows="7" placeholder='Type Your Message Here' required></textarea>
          <button type="submit" className='btn btn-primary'>Send Message</button>
        </form>
      </div>
    </section>
  )
}

export default Contact